/**
 * Copys del aviso que precede a las estrellas de voto, compartidos por las dos
 * ramas de la sección (sistema propio BD y Bazaarvoice) porque el proyecto de
 * diseño reutiliza literalmente el mismo bloque en ambas (Figma
 * 5900:37443 mobile / 5900:33900 desktop sin reseñas, 5900:34468 con reseñas —
 * specs/046-valoraciones-bazaarvoice-bd).
 */
export const RATING_PROMPT_EMPTY = 'Sé el primero a valorar este evento.'
export const RATING_PROMPT_SUMMARY = 'Danos tu opinión sobre este evento:'

/**
 * Analítica del CTA «Déjanos tu opinión» de la rama Bazaarvoice
 * (`components-fingerprint/Opiniones.csv` → "CTA Escribe una opinión": `click`,
 * `click_type=content_link`, `link_text=escribe_una_opinion`,
 * `module_name=contenido_producto`, `module_type=no_aplica`). El destino es el
 * modal de Bazaarvoice, sin URL → `link_url=no_aplica`.
 */
export const REVIEWS_WRITE_LINK_TEXT = 'escribe_una_opinion'
export const REVIEWS_MODULE_NAME = 'contenido_producto'
